export const extractLinks = (text?: string): string[] => {
  if (!text) {
    return []
  }

  const urlRegex =
    /href=["'](https?:\/\/[^\s"']+)|(https?:\/\/[^\s<]+|www\.[^\s<]+)/gi

  const links: string[] = []
  let match: RegExpExecArray | null

  while ((match = urlRegex.exec(text)) !== null) {
    const url = match[1] || match[2]
    if (url) {
      links.push(url)
    }
  }

  return links
}
